import { DOCUMENT, inject, InjectionToken } from '@angular/core';


export const WINDOW = new InjectionToken<Window>('Global window object', {
    factory: () => {
        const document: Document = inject(DOCUMENT);
        return document.defaultView!;
    },
});
